<template>
    <div class="schedule-agent-info">
        <AgentHeadShot class="agent-head" :agent="{ headShots, image, fullName }" dir="width" />

        <div class="info">
            <h3 class="agent-name" v-if="fullName">{{ fullName }}</h3>
            <p class="company" v-if="company">{{ company }}</p>
            <a
                class="email"
                v-if="email"
                :href="mailHref"
                rel="noopener noreferrer"
            >{{ email }}</a>
            <a
                class="phone"
                v-if="phone"
                :href="phoneHref"
                rel="noopener noreferrer"
            >{{ $ft.formatPhone(phone) }}</a>
        </div>
    </div>
</template>

<script>
import AgentHeadShot from "@/components/agent-headshot.vue"
export default {
    inheritAttrs: false,
    props: {
        image: {
            type: String,
            default: ''
        },
        fullName: {
            type: String,
            default: ''
        },
        company: {
            type: String,
            default: ''
        },
        email: {
            type: String,
            default: ''
        },
        phone: {
            type: String,
            default: ''
        },
        headShots: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        mailHref() {
            return `mailto:${this.email}`;
        },
        phoneHref() {
            return `tel:${this.phone}`;
        }
    },
    components: {
        AgentHeadShot
    }
};
</script>
<style lang="scss">
.schedule-agent-info {
    display: flex;
    padding-top: 30px;
    .agent-head {
        flex-shrink: 0;
        width: 65px;
        height: 65px;
        img {
            border-radius: 50%;
        }
    }
    .info {
        color: var(--g-text-color);
        font-size: 12px;
        margin-left: 15px;
        word-break: break-word;
        a,
        p,
        h3 {
            display: block;
            margin: 0 0 6px;
        }
        a {
            text-decoration: underline;
            &:hover {
                color: var(--color-link);
            }
        }
        .agent-name {
            color: var(--g-primary-color);
            font-weight: 700;
            font-size: 16px;
            text-transform: capitalize;
        }
        .phone {
            line-height: 1.5;
        }
    }
}
</style>
